module.exports = __webpack_public_path__ + "static/img/product-02.8deb8f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-02.jpg
// module id = ZXbq
// module chunks = 7